/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';

const Audio = (props) => {
  const {
    value,
  } = props;


  return (
    <ReactAudioPlayer
      src={value}
      controls
    />
  );
};

Audio.propTypes = {
  value: PropTypes.string,
};

Audio.defaultProps = {
  value: '',
};
export default Audio;
